export default __webpack_public_path__ + "static/goodending-4c84da3c3979aaf4f7d97ad403b71d64.gif";